import React, { useContext } from 'react';
import { ComponentContext } from '../../contexts';
export const Area = (genericAreaProps) => {
    const { Area: EditorOrViewerArea } = useContext(ComponentContext);
    return React.createElement(EditorOrViewerArea, { ...genericAreaProps });
};
//# sourceMappingURL=area.js.map